import { ModuloEnMantenimiento } from "src/app/shared/model/mantenimiento-modulos/mantenimiento-modulos.model";
import { Menu } from "src/app/shared/model/security/menu.model";
import { rutaDeMenu } from "src/app/shared/menu/ruta-menu";

/**
 * Las reglas de Mantenimiento de módulos (16/10/2026) que comparten el
 * guardia de rutas, Solicitudes, el diálogo de Tickets y las pantallas del
 * módulo: qué ruta bloquea cada módulo y cómo se dice el aviso.
 */

/** El aviso cuando quien lo puso no escribió uno. */
export const MENSAJE_POR_OMISION = "Estamos dando mantenimiento a esta sección. Vuelve a intentarlo más tarde.";

/** La página del aviso: el guardia nunca la bloquea. */
export const RUTA_AVISO = "en-mantenimiento";

/** La pantalla del módulo. */
export const RUTA_ADMINISTRAR = "/admin/mantenimiento-modulos";

const PREFIJO_MENU = "menu:";
const PREFIJO_TICKET = "ticket:";

/** Las tarjetas de Solicitudes que son hojas del menú (se piden ahí mismo). */
export const CLAVE_IA = PREFIJO_MENU + "admin/solicitudes-ia/solicitud";
export const CLAVE_MANTENIMIENTO = PREFIJO_MENU + "admin/mantenimiento/solicitud";

/**
 * Las tarjetas de ticket que abren una página del módulo de Tickets (las
 * otras dos son diálogos y se cuidan en su botón): esa página también se
 * bloquea.
 */
const RUTAS_TICKET: Record<string, string[]> = {
  [PREFIJO_TICKET + "2"]: ["TICKETS/SolPerfil"],
  [PREFIJO_TICKET + "3"]: ["TICKETS/SolCapacitacion"],
};

/** La clave de una tarjeta de ticket. */
export function claveTicket(idTicket: number): string {
  return PREFIJO_TICKET + idTicket;
}

/** Sin consulta, sin ancla, sin diagonales en las orillas y en minúsculas. */
export function normaliza(url: string | null | undefined): string {
  const sinConsulta = (url || "").split(/[?#]/)[0];
  const partes = sinConsulta.split("/").filter((parte) => parte.trim() !== "");
  return partes.join("/").toLowerCase();
}

/** Las rutas que bloquea un módulo: la de su hoja del menú (la regla del menú lateral) o las de su tarjeta. */
export function rutasDe(modulo: ModuloEnMantenimiento): string[] {
  if (modulo.clave.startsWith(PREFIJO_MENU)) {
    const factory = modulo.factory || modulo.clave.slice(PREFIJO_MENU.length);
    const hoja = { factory, ruta: modulo.ruta } as Menu;
    const padre = modulo.padreFactory ? ({ factory: modulo.padreFactory } as Menu) : undefined;
    return [normaliza(rutaDeMenu(hoja, padre).join("/"))].filter(Boolean);
  }
  return (RUTAS_TICKET[modulo.clave] || []).map(normaliza);
}

/** Si la URL es una de esas rutas o está debajo de alguna. */
export function coincide(url: string, rutas: string[]): boolean {
  const destino = normaliza(url);
  return rutas.some((ruta) => !!ruta && (destino === ruta || destino.startsWith(ruta + "/")));
}

/** «el 20/10/2026 a las 18:30», o vacío si no trae fecha. */
export function textoHasta(hasta: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(hasta || "");
  return m ? `el ${m[3]}/${m[2]}/${m[1]} a las ${m[4]}:${m[5]}` : "";
}

/** El aviso completo: el mensaje (o el de siempre) y, si trae fecha, cuándo vuelve. */
export function textoAviso(modulo: ModuloEnMantenimiento): string {
  const mensaje = (modulo.mensaje || "").trim() || MENSAJE_POR_OMISION;
  const cuando = textoHasta(modulo.hasta);
  return cuando ? `${mensaje} Vuelve a estar disponible ${cuando}.` : mensaje;
}
